// extracted by mini-css-extract-plugin
export default {"iosheader":"appLogo_iosheader__uCsAO","logo":"appLogo_logo__Y1Fng","topBottomSize":"appLogo_topBottomSize__4cCBr","topBottomLine":"appLogo_topBottomLine__9-XT6"};